import { useState } from 'react';
import IUseModals from 'common/types/IUseModals';
import modalsIndex from 'components/Modals/modalsIndex';

const useModals = ():IUseModals => {
  const [modal, setModal] = useState<keyof typeof modalsIndex | null >(null);

  const openModal = (component: keyof typeof modalsIndex) => {
    setModal(component);
  };

  const closeModal = () => {
    setModal(null);
  };

  return ({ closeModal, modal, openModal });
};

export default useModals;